<template>
  <div>
    <el-row>
      <el-col :lg="7"
              :md="9"
              :sm="12"
              :span="6"
              :xl="6"
              :xs="24">
        <img src="images/anze-product.png"
             style="width: 100%"/>
      </el-col>
      <el-col :lg="16"
              :md="14"
              :sm="12"
              :span="18"
              :xl="18"
              :xs="24">
        <div style="margin-left:16px">
          <h2>泰康<span style="color:red;">1-5类</span>雇主险</h2>
          <div style="color:red;">1-5类职业 | 行业超低价 | 全线上操作</div>
          <p>① 1-5类职业，16-65岁可投保，3人起保<br>② 线上保全，次日生效<br>③ 多种方案，自由组合<br>④ 保额最高100万，伤残比例可选<br></p>
          <el-button size="medium"
                     type="warning"
                     @click.native="handleInsure">立即投保
          </el-button>
          <br>
          <el-button :loading="isDownLoading"
                     icon="el-icon-download"
                     size="medium"
                     style="margin-top: 25px"
                     type="text"
                     @click.native="handleDownLoad">下载泰康险职业类别表
          </el-button>
        </div>
      </el-col>

    </el-row>
    <el-tabs v-model="currentStep">
      <el-tab-pane label="保险详情"
                   name="0">
        <el-card>

          <avue-crud ref="plan"
                     :cell-style="onCellStyle"
                     :data="dataPlan"
                     :option="optionPlan"
                     :span-method="spanMethodPlan"
          >
          </avue-crud>

        </el-card>
        <el-card header="短期方案(短期费率系数)">
          <!--          <el-row justify="center" type="flex">-->
          <!--            <div style="display: flex;flex-direction: column;margin-bottom: 20px">-->
          <!--              <span class="red-bold">社保用药100%赔付</span>-->
          <!--            </div>-->
          <!--          </el-row>-->
          <avue-crud ref="crud"
                     :data="dataDq"
                     :option="optionDq">
            <template slot="header">
            </template>
          </avue-crud>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="常见问题"
                   name="1">
        <el-row>
          <el-col :span="20">
            <ul>
              <li v-for="qa in dataQA"
                  :key="qa.question">
                <div>
                  <span style="display:inline-block; width:20px; text-align:center; background-color:MediumPurple; color:white; padding:4px; border-radius:4px; margin-right:8px;">Q</span>
                  <span style="font-weight:bold;">{{ qa.question }}</span>
                </div>
                <p></p>
                <div>
                  <span style="display:inline-block; width:20px; background-color:MediumSeaGreen; color:white; padding: 4px; border-radius: 4px; margin-right: 8px;">A</span>
                  <span style="white-space:pre-wrap;">{{ qa.answer }}</span>
                </div>
                <el-divider></el-divider>
              </li>
            </ul>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="投保须知"
                   name="2">
        <el-row>
          <el-col :span="20">
            <h3>保险条款及须知</h3>
            <p style="line-height:32px;white-space: pre-line"><span class="red-bold">1、投保地区</span>
              本产品仅限在中国大陆注册的合法机构购买，<span class="u-font-weight-bold">实际注册或经营地址在以下地区的单位本产品不予承保</span>：天津市，山东省招远市、禹城市、荣成市、德州市、临沂市，北京平谷区、怀柔区、密云区，河北省三河市、廊坊市、沧州市、秦皇岛市、青龙县，黑龙江省，辽宁省，吉林省，内蒙古自治区通辽市、赤峰市，河南信阳市，湖北省黄冈市、麻城市，江苏省常州市。
              <span class="red-bold">2、生效时间</span>
              线上投保成功后，最早T+2生效。
              <span class="red-bold">3、保单保全</span>
              <span class="red-bold">已发生理赔的人员不可以被替换和批减。线上保全次日生效。</span>
              <span class="red-bold">4、年龄结构</span>
              <span class="red-bold">本产品3人起保，投保年龄：16-65周岁身体健康、能正常工作或正常生活的自然人。如无法证明合法劳动或雇佣关系，本保单不承担赔偿责任；</span>61（含）-65周岁（含）雇员占比不得超过总投保人数的10%，若雇员年龄超过60岁（含），各项责任限额为50%。
              <span class="red-bold">5、行业限制</span>
              本产品仅承保1-5类职业类别雇员，职业分类表以我司为准，具体可承保职业以保险公司核保结果为准。
              5类职业雇员每人伤亡责任限额最高可投50万。
              <span class="red-bold">6、承保公司及适用条款</span>
              本产品由泰康在线财产保险股份有限公司承保，泰康在线财产保险股份有限公司为在线经营的互联网保险公司，无线下分支机构，各项保险服务流程均可线上操作，不影响您的理赔，但在您所在的地区，可能无法直接提供及时的面对面线下服务。
              本产品适用条款如下:
              <table border="1" cellpadding="0" ellspacing="0" style="margin:15px">
                <tr>
                  <th style="width: 50%;">备案名称</th>
                  <th style="width: 50%;">备案编号</th>
                </tr>
                <tr>
                  <td style="text-align: center">《泰康在线财产保险股份有限公司雇主责任保险（C款）》</td>
                  <td style="text-align: center">C00019930912022120268661</td>
                </tr>
                <tr>
                  <td style="text-align: center">《泰康在线财产保险股份有限公司附加24小时人身意外伤害扩展保险》</td>
                  <td style="text-align: center">C00019930922021063099022</td>
                </tr>
                <tr>
                  <td style="text-align: center">《泰康在线财产保险股份有限公司附加行业十级伤残鉴定标准保险》</td>
                  <td style="text-align: center">C00019930922019062517642</td>
                </tr>
                <tr>
                  <td style="text-align: center">《泰康在线财产保险股份有限公司雇主责任保险附加每日住院津贴保险（互联网专属）》</td>
                  <td style="text-align: center">C00019932522021122225403</td>
                </tr>
                <tr>
                  <td style="text-align: center">《泰康在线财产保险股份有限公司附加伤残赔偿比例调整保险（B款）》</td>
                  <td style="text-align: center">C00019930922021092202223</td>
                </tr>
              </table>

              <span class="red-bold">7、保单形式</span>
              网上投保为您提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。您可以登录www.tk.cn自助查询对电子保单的真实性进行验证。产品保险合同将以电子保单和电子普通发票的形式提供，专票出具后进行邮寄。
              <span class="red-bold">8、如实告知</span>
              <span class="red-bold">您应如实填写投保信息，并就保险公司提出的询问据实告知,否则保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同且不承担赔偿责任：
              （1）订立保险合同时，保险公司就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。
              （2）投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。
              （3）投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
              （4）投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，但退还保险费。</span>
              <span class="red-bold">9、相关授权</span>
              如您投保此保险，视为您本人授权泰康在线出于提升保险服务质量之目的，合法的从任何单位、组织和个人获取您有关的资料和证明，作为审核投保、处理理赔及提供与本保险有关其他服务的依据。
              <span class="red-bold">10、信息变更</span>
              如果您的邮件地址、通信地址、邮编、联系电话发生变化，请与本公司客户服务电话95522-3联系，办理变更事宜。
              <span class="red-bold">11、偿付能力信息披露</span>
              保险公司最新季度综合偿付能力充足率、风险综合评级评价结果等信息，请登录保险公司偿付能力信息披露页面http://channel.tk.cn/page/notice/index.html进行查询。
              <span class="red-bold">12、增值税告知</span>
              本保险产品您所缴纳的保费为含税保费，其中包含6%增值税。
              <span class="red-bold">13、反洗钱告知</span>
              本保险产品保费超过人民币20万元时，需提供单位负责人身份证明。
              1）企业营业执照；
              2）法人身份证正反面照片；
              3）负责人身份证正反面照片；
              4）经办人身份证正反面照片；
              5）受益人身份证正反面照片；
              6）泰康在线非自然人客户受益所有人信息采集表。
              <span class="red-bold">14、信息安全</span>
              泰康在线严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。
              <span class="red-bold">15、投诉渠道</span>
              您在购买产品过程中，如发现泰康在线有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向泰康在线投诉，投诉电话：95522-3。
              <span class="red-bold">16、争议处理</span>
              因履行本合同发生的争议，由当事人协商解决，协商不成的，提交武汉仲裁委员会仲裁。
            </p>
            <el-divider></el-divider>
            <h3>特别约定 </h3><span class="red-bold"></span>
            <p style="line-height:32px;white-space: pre-line">1、<span class="red-bold">本产品仅限在中国大陆注册的合法机构购买，实际注册或经营地址在以下地区的单位本产品不予承保：</span>天津市，山东省招远市、禹城市、荣成市、德州市、临沂市，北京平谷区、怀柔区、密云区，河北省三河市、廊坊市、沧州市、秦皇岛市、青龙县，黑龙江省，辽宁省，吉林省，内蒙古自治区通辽市、赤峰市，河南信阳市，湖北省黄冈市、麻城市，江苏省常州市。
              2、投保人及被保人名称中含有以下所列关键词的:钢铁、建筑、钢丝绳、钢绳、危险品、渔业、爆破、幕墙、脚手架、建设、石材、拆、矿业、采石、劳联、产联、疏浚、铁塔、电梯、造船、船舶维修、船舶修造、船舶工程、船务、重工，保险公司不予承保。
              3、本方案3人起保，承保雇员需为16周岁（含）-65周岁（含）身体健康、能正常工作或正常生活的自然人，雇员需提供清单记名投保，61（含）-65周岁（含）雇员占比不得超过总投保人数的10%，若雇员年龄超过60岁（含），各项责任限额为50%。
              4、本保险所指的雇员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员、个体工商户的负责人、法人代表或个体工商户营业执照上列明的经营者等与被保险人存在实际雇佣关系的工作人员。
              5、被保险雇员必须与被保险人存在实际雇佣关系，否则，保险公司有权拒绝赔偿。
              6、同一保险期间内，同一雇员只允许购买一份保单。
              7、本保险承保雇员的职业范围：《职业分类表》中的1-5级职业等级（标注拒保的除外）；雇员是否涉高以保单中雇员清单信息约定为准，如保单中约定雇员不涉高，出险时雇员从事高处作业，保险人不承担赔偿责任。高处作业以《高处作业分级标准》(中华人民共和国国家标准GB3608-2008)中的定义为准(在距坠落高度基准面2m或2m以上有可能坠落的高处进行作业)。若不属于本保险承保雇员的职业范围请勿投保；<span
                class="red-bold">如出险时被保险人的雇员工作类型所对应的职业属于本产品拒保职业的，保险人不承担赔偿责任，拒保职业清单详见保单。</span>
              8、本保险医疗费用每次免赔200元，赔付比例100%。
              9、经医院证明，误工费每次事故免赔3天，赔偿公式为：每日赔偿限额（每日赔偿限额在保单中约定）×(实际暂时丧失工作能力天数-3天)，每次不超过90天，累计不超过180天，该雇员在评定伤残等级后，本项赔偿责任终止。
              10、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承担赔偿责任。对身故、伤残案件，能核实事故真实情况，但报案超过案发时间72小时（含）以上的，按损失金额的50%免赔后进行赔付；对非身故、伤残的其他案件，能核实事故真实情况，但报案超过案发时间1个月以上（含1个月）的，按损失金额的50%免赔后进行赔付。本特别约定与主险条款内容相悖之处，以本特别约定为准；未尽之处，以主险条款为准。
              11、本保险项下，医疗费用的赔付范畴依据被保险人所在省份的基本医疗保险的相关药品目录及诊疗项目目录及其相应比例执行。除紧急抢救外，被保险人均应在二级以上（含二级）医院或保险人认可的医疗机构就诊。未在保险人认可的医疗机构就诊的，保险人有权拒绝赔付。北京平谷区、密云区，河北省廊坊市、青龙县、三河市，天津滨海区、静海区，辽宁铁岭市，山东禹城市、招远市、荣成市，河南信阳市下辖的各医疗机构，不在保险公司认可医院范围内，即上述地区医疗机构的医疗发票、伤残鉴定报告、死亡事故说明等均不属于保险公司理赔范畴，且不承担任何保单责任。
              12、本保单承保被保险人雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（既往症原因除外），本保单项下雇员赔偿限额不超过30万。既往症原因导致的猝死不属于本保单赔偿范围。既往症指如下情况：被保险人的雇员患有恶性肿瘤、心脏病（心功能不全II级及II级以上）、心肌梗塞、白血病、高血压病（2级以上）、肝硬化、慢性阻塞性肺疾病、脑血管疾病、慢性肾脏疾病、糖尿病、再生障碍性贫血、先天性畸形、变形和染色体异常、精神和行为障碍（依照世界卫生组织《疾病和有关健康问题的国际统计分类（ICD-10）》确定）、《中华人民共和国传染病防治法》规定的甲类及乙类传染病(含艾滋病)、癫痫病及正患病住院及全休、半休状态。
              13、本产品承保的雇员因交通事故发生的死亡、伤残、医疗案件，对出险的雇员属于工伤保险认定范围内的交通事故进行赔偿。
              14、本产品承保雇员以附件上传名单为准，若本保单被保险人雇员实际职业类别高于保单人员清单列明职业类别的，保险人退还保险费，不承担保险责任。
              15、从事5类及以上特种作业岗位和高空岗位，按照国家规定须具有特种作业证和高空作业证，出险时如未能提供特种作业证和高空作业证，免赔率为80%。
              16、本保单可以增人，增人按日计费。保险期限1-3个月的保单不可减人和换人，保险期限超过3个月的保单可以减人或换人，换人规则：<span class="red-bold">替换的人员职业等级需一致，不同职业等级人员之间不可互换；已替换出的人员不允许再次替换或批增。已批减的人员不允许替换或再次批增。已出险人员（含已报案未理赔和已理赔）不可以被替换和批减。线上保全次日生效。</span>
              17、如附加《泰康在线财产保险股份有限公司附加伤残赔偿比例调整保险（B款）》保险时，该附加险项下评残标准同样适用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014），按照工伤伤残赔偿标准确定残疾赔偿金，最高以每人伤亡责任限额乘以伤残等级对应的比例为限，伤残等级赔偿限额比例表：一级伤残100%、二级伤残80%、三级伤残70%、四级伤残60%、五级伤残40%、六级伤残30%、七级伤残20%、八级伤残15%、九级伤残7%、十级伤残5%。（如未附加，本条无效）
              18、如附加《泰康在线财产保险股份有限公司附加行业十级伤残鉴定标准保险》保险时，该附加险项下评残标准同样适用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014），按照工伤伤残赔偿标
              准确定残疾赔偿金，最高以每人伤亡责任限额乘以伤残等级对应的比例为限，伤残等级赔偿限额比例表：一级伤残100%、二级伤残90%、三级伤残80%、四级伤残70%、五级伤残60%、六级伤残50%、七级伤残40%、八级伤残30%、九级伤残20%、十级伤残10%。（如未附加，本条无效）
              19、如附加《泰康在线财产保险股份有限公司附加24小时人身意外伤害扩展保险》保险时，该附加险项下：包含死亡伤残、意外医疗费和误工费保障；每人死亡伤残、医疗费和误工费赔偿限额与主险责任限额相同。该附加险项下意外伤残事故评残标准为人身保险伤残评定标准（行业标准）（中保协发（2013）88号）。（如未附加，本条无效）.
              20、每日住院津贴保险责任每次事故免赔3天，单次不超90天，累计不超180天，对于雇员的挂床行为，保险人不承担住院津贴给付的保险责任。
            </p>
            <el-divider></el-divider>
            <h3>投保声明 </h3>
            <p style="line-height:32px; white-space: pre-line">1、<span
              class="red-bold">本公司已完整阅读并了解以上投保须知及投保险种的保险条款，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本公司已充分理解并接受上述内容，同意以此作为订立保险合同的依据。</span>
              2、投保单中所填写的内容均属实，如有隐瞒或不实告知，保险公司有权解除保险合同，对于合同解除前发生的任何事故，保险公司可不承担任何责任。
              3、保险责任开始后，投保人要求解除保险合同的，自通知保险人之日起，保险合同解除，保险人收取自保险责任开始之日起至合同解除之日止期间的按日比例计收的保险费，并退还剩余部分保险费。
              4、本公司同意保险公司通过手机（包括手机短信）、E-mail适时提供保险信息服务。
            </p>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import {optionAddFeeRate, optionDq, optionPlanAnZeGZ, optionPremium, optionPremiumRestrict} from '@/const/crud/insurance/productDetail'

export default {
  name: 'Product45Details',
  props: {
    productId: {
      type: String | Number,
      required: true,
    },
  },
  data: function () {
    return {
      currentStep: '0',
      optionPlan: optionPlanAnZeGZ,
      optionPremium: optionPremium,
      optionPremiumRestrict: optionPremiumRestrict,
      optionDq: optionDq,
      optionAddFeeRate: optionAddFeeRate,
      dataPlan: [
        {
          plan0: '泰康1-5类雇主险',
        },
        {
          plan0: '雇主责任保障（61-65周岁最高可投50万，5类最高可投50万）',
        },
        {
          plan0: '项目',
          plan2: '10万',
          plan3: '20万',
          plan4: '30万',
          plan5: '40万',
          plan6: '50万',
          plan7: '60万',
          plan8: '70万',
          plan9: '80万',
          plan10: '90万',
          plan11: '100万',
        },
        {
          plan0: '工伤及职业病身故伤残',

          plan2: '10万/人',
          plan3: '20万/人',
          plan4: '30万/人',
          plan5: '40万/人',
          plan6: '50万/人',
          plan7: '60万/人',
          plan8: '70万/人',
          plan9: '80万/人',
          plan10: '90万/人',
          plan11: '100万/人',
        },
        {
          plan0: '工伤医疗',
          plan2: '1万/人',
          plan3: '2万/人',
          plan4: '3万/人',
          plan5: '4万/人',
          plan6: '5万/人',
          plan7: '6万/人',
          plan8: '7万/人',
          plan9: '8万/人',
          plan10: '9万/人',
          plan11: '10万/人',
        },
        {
          plan0: '法律费用',
          plan2: '累计赔偿责任限额10万，每次事故赔偿责任限额1万',
        },
        {
          plan0: '误工费用',
          plan2: '50元/天、100元/天、150元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
        },
        {
          plan0: '住院津贴',
          plan2: '50元/天、100元/天、150元/天，单次免赔3天，单次赔付最高90天，累计最高180天',
        },
        {
          plan0: '医疗免赔',
          plan2: '医疗免赔200元后100%赔付',
        },
        {

          //95.0 	185.0 	275.0 	365.0 	455.0 	545.0 	635.0 	725.0 	815.0 	905.0

          plan0: '1-2类(不涉高)保费',
          plan1: '伤残赔付比例10级5%',
          plan2: '95.0',
          plan3: '185.0',
          plan4: '275.0',
          plan5: '365.0',
          plan6: '455.0',
          plan7: '545.0',
          plan8: '635.0',
          plan9: '725.0',
          plan10: '815.0',
          plan11: '905.0',
        },
        {
          //109.3 	212.8 	316.3 	419.8 	523.3 	626.8 	730.3 	833.8 	937.3 	1,040.8
          plan0: '1-2类(不涉高)保费',
          plan1: '伤残赔付比例10级5%+扩展24小时',
          plan2: '109.3',
          plan3: '212.8',
          plan4: '316.3',
          plan5: '419.8',
          plan6: '523.3',
          plan7: '626.8',
          plan8: '730.3',
          plan9: '833.8',
          plan10: '937.3',
          plan11: '1040.8',
        },
        {
          //123.5 	240.5 	357.5 	474.5 	591.5 	708.5 	825.5 	942.5 	1,059.5 	1,176.5
          plan0: '1-2类(不涉高)保费',
          plan1: '伤残赔付比例10级10%',
          plan2: '123.5',
          plan3: '240.5',
          plan4: '357.5',
          plan5: '474.5',
          plan6: '591.5',
          plan7: '708.5',
          plan8: '825.5',
          plan9: '942.5',
          plan10: '1059.5',
          plan11: '1176.5',
        },
        {
          //137.8 	268.3 	398.8 	529.3 	659.8 	790.3 	920.8 	1,051.3 	1,181.8 	1,312.3
          plan0: '1-2类(不涉高)保费',
          plan1: '伤残赔付比例10级10%+扩展24小时',
          plan2: '137.8',
          plan3: '268.3',
          plan4: '398.8',
          plan5: '529.3',
          plan6: '659.8',
          plan7: '790.3',
          plan8: '920.8',
          plan9: '1051.3',
          plan10: '1181.8',
          plan11: '1312.3',
        },


        {
          "plan0": "3类(不涉高)保费",
          "plan1": "伤残赔付比例10级5%",
          "plan2": "136.0",
          "plan3": "271.0",
          "plan4": "400.0",
          "plan5": "529.0",
          "plan6": "658.0",
          "plan7": "787.0",
          "plan8": "916.0",
          "plan9": "1045.0",
          "plan10": "1174.0",
          "plan11": "1303.0",
        }, {
          "plan0": "3类(不涉高)保费",
          "plan1": "伤残赔付比例10级5%+扩展24小时",
          "plan2": "156.4",
          "plan3": "311.7",
          "plan4": "460.0",
          "plan5": "608.4",
          "plan6": "756.7",
          "plan7": "905.1",
          "plan8": "1053.4",
          "plan9": "1201.8",
          "plan10": "1350.1",
          "plan11": "1498.5",
        }, {
          "plan0": "3类(不涉高)保费",
          "plan1": "伤残赔付比例10级10%",
          "plan2": "176.8",
          "plan3": "352.3",
          "plan4": "520.0",
          "plan5": "687.7",
          "plan6": "855.4",
          "plan7": "1023.1",
          "plan8": "1190.8",
          "plan9": "1358.5",
          "plan10": "1526.2",
          "plan11": "1693.9",
        }, {
          "plan0": "3类(不涉高)保费",
          "plan1": "伤残赔付比例10级10%+扩展24小时",
          "plan2": "197.2",
          "plan3": "393.0",
          "plan4": "580.0",
          "plan5": "767.1",
          "plan6": "954.1",
          "plan7": "1141.2",
          "plan8": "1328.2",
          "plan9": "1515.3",
          "plan10": "1702.3",
          "plan11": "1889.4",
        }, {
          "plan0": "4类(不涉高)保费",
          "plan1": "伤残赔付比例10级5%",
          "plan2": "150.0",
          "plan3": "300.0",
          "plan4": "443.0",
          "plan5": "585.0",
          "plan6": "728.0",
          "plan7": "870.0",
          "plan8": "1013.0",
          "plan9": "1155.0",
          "plan10": "1298.0",
          "plan11": "1440.0",
        }, {
          "plan0": "4类(不涉高)保费",
          "plan1": "伤残赔付比例10级5%+扩展24小时",
          "plan2": "172.5",
          "plan3": "345.0",
          "plan4": "509.5",
          "plan5": "672.8",
          "plan6": "837.2",
          "plan7": "1000.5",
          "plan8": "1165.0",
          "plan9": "1328.3",
          "plan10": "1492.7",
          "plan11": "1656.0",
        }, {
          "plan0": "4类(不涉高)保费",
          "plan1": "伤残赔付比例10级10%",
          "plan2": "195.0",
          "plan3": "390.0",
          "plan4": "575.9",
          "plan5": "760.5",
          "plan6": "946.4",
          "plan7": "1131.0",
          "plan8": "1316.9",
          "plan9": "1501.5",
          "plan10": "1687.4",
          "plan11": "1872.0",
        }, {
          "plan0": "4类(不涉高)保费",
          "plan1": "伤残赔付比例10级10%+扩展24小时",
          "plan2": "217.5",
          "plan3": "435.0",
          "plan4": "642.4",
          "plan5": "848.3",
          "plan6": "1055.6",
          "plan7": "1261.5",
          "plan8": "1468.9",
          "plan9": "1674.8",
          "plan10": "1882.1",
          "plan11": "2088.0",
        }, {
          "plan0": "特殊4类(不涉高)保费",
          "plan1": "伤残赔付比例10级5%",
          "plan2": "186.0",
          "plan3": "372.0",
          "plan4": "549.3",
          "plan5": "725.4",
          "plan6": "902.7",
          "plan7": "1078.8",
          "plan8": "1256.1",
          "plan9": "1432.2",
          "plan10": "1609.5",
          "plan11": "1785.6",
        }, {
          "plan0": "特殊4类(不涉高)保费",
          "plan1": "伤残赔付比例10级5%+扩展24小时",
          "plan2": "213.9",
          "plan3": "427.8",
          "plan4": "631.7",
          "plan5": "834.2",
          "plan6": "1038.1",
          "plan7": "1240.6",
          "plan8": "1444.5",
          "plan9": "1647.0",
          "plan10": "1850.9",
          "plan11": "2053.4",
        }, {
          "plan0": "特殊4类(不涉高)保费",
          "plan1": "伤残赔付比例10级10%",
          "plan2": "241.8",
          "plan3": "483.6",
          "plan4": "714.1",
          "plan5": "943.0",
          "plan6": "1173.5",
          "plan7": "1402.4",
          "plan8": "1633.0",
          "plan9": "1861.9",
          "plan10": "2092.4",
          "plan11": "2321.3",
        }, {
          "plan0": "特殊4类(不涉高)保费",
          "plan1": "伤残赔付比例10级10%+扩展24小时",
          "plan2": "269.7",
          "plan3": "539.4",
          "plan4": "796.5",
          "plan5": "1051.8",
          "plan6": "1308.9",
          "plan7": "1564.3",
          "plan8": "1821.4",
          "plan9": "2076.7",
          "plan10": "2333.8",
          "plan11": "2589.1",
        }, {
          "plan0": "4类/特殊4类(涉高)保费",
          "plan1": "伤残赔付比例10级5%",
          "plan2": "315.0",
          "plan3": "630.0",
          "plan4": "930.3",
          "plan5": "1228.5",
          "plan6": "1528.8",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "4类/特殊4类(涉高)保费",
          "plan1": "伤残赔付比例10级5%+扩展24小时",
          "plan2": "362.3",
          "plan3": "724.5",
          "plan4": "1069.8",
          "plan5": "1412.8",
          "plan6": "1758.1",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "4类/特殊4类(涉高)保费",
          "plan1": "伤残赔付比例10级10%",
          "plan2": "409.5",
          "plan3": "819.0",
          "plan4": "1209.4",
          "plan5": "1597.1",
          "plan6": "1987.4",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "4类/特殊4类(涉高)保费",
          "plan1": "伤残赔付比例10级10%+扩展24小时",
          "plan2": "456.8",
          "plan3": "913.5",
          "plan4": "1348.9",
          "plan5": "1781.3",
          "plan6": "2216.8",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级5%",
          "plan2": "314.0",
          "plan3": "629.0",
          "plan4": "927.0",
          "plan5": "1226.0",
          "plan6": "1524.0",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级5%+扩展24小时",
          "plan2": "361.1",
          "plan3": "723.4",
          "plan4": "1066.1",
          "plan5": "1409.9",
          "plan6": "1752.6",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级10%",
          "plan2": "408.2",
          "plan3": "817.7",
          "plan4": "1205.1",
          "plan5": "1593.8",
          "plan6": "1981.2",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级10%+扩展24小时",
          "plan2": "455.3",
          "plan3": "912.1",
          "plan4": "1344.2",
          "plan5": "1777.7",
          "plan6": "2209.8",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "特殊5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级5%",
          "plan2": "471.0",
          "plan3": "943.5",
          "plan4": "1390.5",
          "plan5": "1839.0",
          "plan6": "2286.0",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "特殊5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级5%+扩展24小时",
          "plan2": "541.7",
          "plan3": "1085.0",
          "plan4": "1599.1",
          "plan5": "2114.9",
          "plan6": "2628.9",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "特殊5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级10%",
          "plan2": "612.3",
          "plan3": "1226.6",
          "plan4": "1807.7",
          "plan5": "2390.7",
          "plan6": "2971.8",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        }, {
          "plan0": "特殊5类(无论涉高或不涉高)保费",
          "plan1": "伤残赔付比例10级10%+扩展24小时",
          "plan2": "683.0",
          "plan3": "1368.1",
          "plan4": "2016.2",
          "plan5": "2666.6",
          "plan6": "3314.7",
          "plan7": "/",
          "plan8": "/",
          "plan9": "/",
          "plan10": "/",
          "plan11": "/",
        },


      ],
      dataQA: [
        {
          question: '本产品的保险公司是哪家？',
          answer:
            '由世界500强泰康保险集团的全资子公司—泰康在线财产保险股份有限公司承保。',
        },
        {
          question: '泰康1-5雇主责任险责任范围包括哪些？',
          answer: `1、在保险期间内，凡被保险人的雇员在中华人民共和国境内（不包括港、澳、
台地区）因下列情形所致伤、残或死亡，依照中华人民共和国法律（不包括港、澳、台地区
法律）应由被保险人承担的经济赔偿责任，保险人按照本保险合同约定负责赔偿：
（一） 在工作时间和工作场所内，因工作原因发生意外事故受到伤害；
（二） 工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作因意外
事故受到伤害；
（三） 在工作时间和工作场所内，因履行工作职责受到暴力等意外伤害；
（四） 被诊断、鉴定为职业病；
（五） 因工外出期间，由于工作原因受到伤害或者发生事故下落不明；
（六） 在上下班途中，因发生非本人主要责任交通事故及其他意外事故受到伤害；
（七） 在工作时间和工作岗位，突发疾病死亡或者在 48 小时之内经抢救无效死亡；
（八） 在抢险救灾等维护国家利益、公共利益活动中受到伤害；
（九） 原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到被保险人处
工作后旧伤复发；
（十） 法律、行政法规规定应当认定为工伤的其他情形。
2、保险事故发生后，被保险人因保险事故而被提起仲裁或者诉讼的，对应由被
保险人支付的仲裁或者诉讼费用以及事先经保险人书面同意支付的其它必要的、合理的费用
（以下简称“法律费用”），保险人按照本保险合同约定也负责赔偿。`,
        },
        {
          question: '方案被保险人与雇员关系怎么定义？',
          answer: `本保险所指的雇员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员、个体工商户的负责人、法人代表或个体工商户营业执照上列明的经营者等与被保险人存在实际雇佣关系的工作人员。`,
        },
        {
          question: '哪些职业不保？',
          answer: `本产品仅承保1-5类职业类别雇员，职业分类表以我司为准，具体可承保职业以保险公司核保结果为准。若不属于本保险承保雇员的职业范围请勿投保；如出险时被保险人的雇员工作类型所对应的职业属于本产品拒保职业的，保险人不承担赔偿责任，拒保职业清单详见保单。`,
        },
        {
          question: '如果投保，无对应职业可选择，应如何处理？',
          answer: '请咨询平台工作人员，由专业客服为您解答。否则，保险人可能拒保。',
        },
        {
          question: '怎么投保？怎么支付？',
          answer:
            '直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→线上支付保费→获取保单。',
        },
        {
          question: '保单和发票怎么获取？',
          answer:
            '线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，当客户选择专票时，由泰康在线开具专票后进行邮寄。',
        },
        {
          question: '保单如何查验真伪？',
          answer:
            '可以通过拨打泰康在线全国客服电话95522-3-3-1进行人工查询或者登录泰康在线客服中心网站输入保单号、投保人证件号进行自助查询https://www.tk.cn/scsy/bdzzcx/',
        },
        {
          question: '雇员变动怎么办？',
          answer:
            '本保单可以增人，增人按日计费。保险期限超过 3 个月 的保单可以替换人员。保险期限超过 3 个月 的保单可以换人已发生理赔的人员不可以被替换和批减。线上保全次日生效。',
        },
        {
          question: '出险员工是否可替换出去？',
          answer: '不可以。',
        },
      ],
      dataDq: [
        {
          prop1: '15%',
          prop2: '25%',
          prop3: '35%',
          prop4: '40%',
          prop5: '50%',
          prop6: '60%',
          prop7: '70%',
          prop8: '80%',
          prop9: '85%',
          prop10: '90%',
          prop11: '95%',
        },
      ],
      isDownLoading: false,
    }
  },
  created() {

    /**
     * /*
     *         *
     *         * 帮我把以下表格的数据转换为类似数据结构 参考
     *         * [{
     *          plan0: '3类（不涉高）保费',
     *          plan1: '伤残赔付比例10级5%+扩展24小时',
     *          plan2: '120.8',
     *          plan3: '241.5',
     *          plan4: '345.0',
     *          plan5: '458.9',
     *          plan6: '546.3',
     *          plan7: '655.5',
     *          plan8: '803.0',
     *          plan9: '868.3',
     *          plan10: '968.3',
     *          plan11: '1,078.7',
     *          }]
     *          3类（不涉高）保费  伤残赔付比例10级5%  136.0  271.0  400.0  529.0  658.0  787.0  916.0  1,045.0  1,174.0  1,303.0
     *          3类（不涉高）保费  伤残赔付比例10级5%+扩展24小时  156.4  311.7  460.0  608.4  756.7  905.1  1,053.4  1,201.8  1,350.1  1,498.5
     *          3类（不涉高）保费  伤残赔付比例10级10%  176.8  352.3  520.0  687.7  855.4  1,023.1  1,190.8  1,358.5  1,526.2  1,693.9
     *          3类（不涉高）保费  伤残赔付比例10级10%+扩展24小时  197.2  393.0  580.0  767.1  954.1  1,141.2  1,328.2  1,515.3  1,702.3  1,889.4
     *          4类(不涉高)保费 伤残赔付比例10级5%  150.0  300.0  443.0  585.0  728.0  870.0  1,013.0  1,155.0  1,298.0  1,440.0
     *          4类(不涉高)保费  伤残赔付比例10级5%+扩展24小时  172.5  345.0  509.5  672.8  837.2  1,000.5  1,165.0  1,328.3  1,492.7  1,656.0
     *          4类(不涉高)保费  伤残赔付比例10级10%  195.0  390.0  575.9  760.5  946.4  1,131.0  1,316.9  1,501.5  1,687.4  1,872.0
     *          4类(不涉高)保费  伤残赔付比例10级10%+扩展24小时  217.5  435.0  642.4  848.3  1,055.6  1,261.5  1,468.9  1,674.8  1,882.1  2,088.0
     *          特殊4类(不涉高)保费  伤残赔付比例10级5%  186.0  372.0  549.3  725.4  902.7  1,078.8  1,256.1  1,432.2  1,609.5  1,785.6
     *          特殊4类(不涉高)保费  伤残赔付比例10级5%+扩展24小时  213.9  427.8  631.7  834.2  1,038.1  1,240.6  1,444.5  1,647.0  1,850.9  2,053.4
     *          特殊4类(不涉高)保费  伤残赔付比例10级10%  241.8  483.6  714.1  943.0  1,173.5  1,402.4  1,633.0  1,861.9  2,092.4  2,321.3
     *          特殊4类(不涉高)保费  伤残赔付比例10级10%+扩展24小时  269.7  539.4  796.5  1,051.8  1,308.9  1,564.3  1,821.4  2,076.7  2,333.8  2,589.1
     *          4类/特殊4类（涉高）保费  伤残赔付比例10级5%  315.0  630.0  930.3  1,228.5  1,528.8  /  /  /  /  /
     *          4类/特殊4类（涉高）保费伤残赔付比例10级5%+扩展24小时  362.3  724.5  1,069.8  1,412.8  1,758.1  /  /  /  /  /
     *          4类/特殊4类（涉高）保费伤残赔付比例10级10%  409.5  819.0  1,209.4  1,597.1  1,987.4  /  /  /  /  /
     *          4类/特殊4类（涉高）保费伤残赔付比例10级10%+扩展24小时  456.8  913.5  1,348.9  1,781.3  2,216.8  /  /  /  /  /
     *          5类保费  伤残赔付比例10级5%  314.0  629.0  927.0  1,226.0  1,524.0  /  /  /  /  /
     *          5类保费  伤残赔付比例10级5%+扩展24小时  361.1  723.4  1,066.1  1,409.9  1,752.6  /  /  /  /  /
     *          5类保费  伤残赔付比例10级10%  408.2  817.7  1,205.1  1,593.8  1,981.2  /  /  /  /  /
     *          5类保费  伤残赔付比例10级10%+扩展24小时  455.3  912.1  1,344.2  1,777.7  2,209.8  /  /  /  /  /
     *          特殊5类保费  伤残赔付比例10级5%  471.0  943.5  1,390.5  1,839.0  2,286.0  /  /  /  /  /
     *          特殊5类保费  伤残赔付比例10级5%+扩展24小时  541.7  1,085.0  1,599.1  2,114.9  2,628.9  /  /  /  /  /
     *          特殊5类保费  伤残赔付比例10级10%  612.3  1,226.6  1,807.7  2,390.7  2,971.8  /  /  /  /  /
     *          特殊5类保费  伤残赔付比例10级10%+扩展24小时  683.0  1,368.1  2,016.2  2,666.6  3,314.7  /  /  /  /  /
     *         *
     *          // 参考以上注释生成数组
     *
     *
     *
     *
     *
     *
     *         * */


  },
  methods: {
    spanMethodPlan({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0 || rowIndex === 1) {
        return [1, 12]
      }
      if (rowIndex > 1 && rowIndex < 9) {
        if (columnIndex === 0) {
          return [1, 2]
        }
        if (columnIndex === 1) {
          return [0, 0]
        }
        if (rowIndex == 5 || rowIndex == 6 || rowIndex == 7 || rowIndex == 8) {
          if (columnIndex === 2) {
            return [1, 10]
          } else {
            return [0, 0]
          }
        }
      }

      if (rowIndex === 0) {
        return [1, 2]
      }

      //四个合并
      if (rowIndex > 8 && rowIndex < 37 && columnIndex == 0) {
        if (rowIndex - 9 == 0 || (rowIndex - 9) % 4 == 0) {
          return {
            rowspan: 4,
            colspan: 1,
          }
        } else {
          return [0, 0]
        }
      }
    },
    handleInsure() {
      this.$emit('insure')
    },
    handleDownLoad() {
      this.isDownLoading = true
      let fileName = `tk_${
        this.productId
      }_template_chinalife_${currentYYYYmmdd()}.xlsx`
      handleDownCategoryFile(
        `/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
        {},
        fileName,
      )
        .then(() => {
          //下载成功
        })
        .finally(() => {
          this.isDownLoading = false
        })
    },
    onCellStyle({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return {
          fontWeight: 'bold',
          fontSize: '18px',
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.red-bold {
  color: red;
  font-weight: bold;
}

.el-col {
  font-size: 14px;
}

.el-card {
  font-size: 14px;
  margin-bottom: 16px;
}

.item {
  margin-bottom: 18px;
}

.ul,
li {
  list-style: none;
}

span.link {
  display: block;
  text-indent: 1em;
}

h2 {
  margin: 0;
  padding: 0;
}
</style>
